export enum ActionType {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  INFO = 'INFO',
  COUPON = 'COUPON',
  STATS = 'STATS',
  PAYMENT = 'PAYMENT',
  PUBLISH = 'PUBLISH',
  ARCHIVE = 'ARCHIVE',
}

export interface HeaderColumns {
  title: string;
  key: string;
  isSortable: boolean;
}

// export interface Pagination {
//   pageSize: number;
//   currentPage: number;
//   totalCount: number;
//   filteredData: string;
//   sortedColumn: string;
//   sortOrder: 'asc' | 'desc';
// }

export interface FilteredObj{
  key:string;
  value: string[] | number[];
}

export interface TableRequest{
  pageSize:number;
  currentPage:number;
  totalCount?:number;
  searchValue?:string;
  filteredValue?:FilteredObj[];
  sortColumn:string;
  sortOrder:'asc'|'desc'
}

export interface ITable {
  message: string;
  data: Data;
  status: string;
  success: boolean;
}
export interface Data {
  columnList: ColumnList[];
  tableData: any[];
  actionItems: ActionType[];
  pageInfo: PageInfo;
}
export interface PageInfo {
  pageSize: number;
  currentPage: number;
  totalCount: number;
}
export interface TableDatum {
  _id: string;
  name: string;
  rank: number;
  sellingPrice: number;
  discount: number;
  status: string;
  stock: number;
}
export interface ColumnList {
  title: string;
  key: string;
  isSortable: boolean;
}
